import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-184" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-185" data-mp="j76t2jrmpvor">
        <SectionHeading id="summary-title" data-id="element-186" data-mp="j8hw2hd92zet">Everything <span className="text-highlight" data-id="element-187" data-mp="j5c6z24mfxj3">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-primary/60 bg-surface sm:grid-cols-2" data-id="element-188" data-mp="1gu5sh29phhqc">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-primary/15 p-4 sm:odd:border-r" data-id="element-189" data-mp="16whmfg6ngnsv">
              <span className="glow-line mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-highlight" data-id="element-190" data-mp="12vxpodpznm79">
                <CheckIcon className="h-3.5 w-3.5 text-background" aria-hidden="true" data-id="element-191" data-mp="3rojqmrffxm8n" />
              </span>
              <b className="text-sm text-foreground" data-id="element-192" data-mp="3njtxhac62lrf">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}